import {FC, ReactNode} from "react";
import {DialogTitle} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {CloseOutlined} from "@mui/icons-material";

export interface Props {
    children?: ReactNode;
    onClose: () => void;
}

const CustomDialogTitle: FC<Props> = (props) => {
    const {children, onClose, ...other} = props;

    return (
        <DialogTitle sx={{m: 0, pt: 1.5, pb: 2.5, pl: 3, pr: 6, fontWeight: 600}} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseOutlined/>
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

export default CustomDialogTitle
